import type { OnboardingAnswers, Question } from "../../../types/onboarding";
import { MultiSelectQuestion } from "./base/MultiSelectQuestion";

interface FertilityPathQuestionProps {
	question: Question;
	answers: OnboardingAnswers;
	onInputChange: (field: string, value: string | string[]) => void;
}

export function FertilityPathQuestion({
	question,
	answers,
	onInputChange,
}: FertilityPathQuestionProps) {
	return (
		<MultiSelectQuestion
			question={question}
			answers={answers}
			onInputChange={onInputChange}
			translationMappingKey="fertilityPath"
			placeholderTranslationKey="questions.fertilityPath.selectAllThatApply"
			eventPrefix="path"
			maxSelections={3}
		/>
	);
}
